import { Injectable } from '@angular/core';
import { getApps, initializeApp } from 'firebase/app';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  getFirestore,
} from 'firebase/firestore';
import { firebaseConfig } from '../../environments/firebase';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FirebaseService {
  readonly app = (() => {
    const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
    void this.initAppCheck(app);
    return app;
  })();
  readonly db = (() => {
    try {
      return initializeFirestore(this.app, {
        localCache: persistentLocalCache({
          tabManager: persistentMultipleTabManager(),
        }),
      });
    } catch {
      // Already initialized — return existing instance
      return getFirestore(this.app);
    }
  })();

  private async initAppCheck(app: ReturnType<typeof initializeApp>): Promise<void> {
    if (!environment.appCheckEnabled) return;

    const { initializeAppCheck, ReCaptchaV3Provider } = await import('firebase/app-check');
    try {
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(environment.recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true,
      });
    } catch {
      // App Check may already be initialized by the lazy auth bootstrap.
    }
  }
}
